"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../createApi");

var UsersCoreApi = function (_BaseApi) {
  (0, _inherits2["default"])(UsersCoreApi, _BaseApi);

  function UsersCoreApi() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, UsersCoreApi);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(UsersCoreApi)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserChallenges", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          userId = _ref.userId,
          clientId = _ref.clientId,
          params = _ref.params;

      return _this.api.get("/v3/users/".concat(userId, "/clients/").concat(clientId, "/all-challenges"), {
        params: params
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUsers", function (_ref2) {
      var clientId = _ref2.clientId,
          limit = _ref2.limit,
          skip = _ref2.skip;
      return _this.api.get('/v3/users', {
        params: {
          'client-id': clientId,
          limit: limit,
          skip: skip
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "uploadProfilePicture", function (_ref3) {
      var userId = _ref3.userId,
          clientId = _ref3.clientId,
          formData = _ref3.formData;
      return _this.api.post("/v3/users/".concat(userId, "/upload"), {
        params: {
          'client-id': clientId
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateUser", function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref4.id,
          data = _ref4.data,
          clientId = _ref4.clientId;

      return _this.api.put("/v3/users/".concat(id), {
        params: {
          'client-id': clientId
        },
        data: data
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserChallengeStats", function () {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          clientId = _ref5.clientId,
          userId = _ref5.userId,
          challengeId = _ref5.challengeId;

      return _this.api.get("/v3/users/".concat(userId, "/challenges/").concat(challengeId, "/stats"), {
        params: {
          'client-id': clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserChallengeAttempts", function () {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          clientId = _ref6.clientId,
          userId = _ref6.userId,
          challengeId = _ref6.challengeId;

      return _this.api.get("/v3/users/".concat(userId, "/challenges/").concat(challengeId, "/attempts"), {
        params: {
          'client-id': clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteUserRegisteredFromLeaderboard", function (_ref7) {
      var clientId = _ref7.clientId,
          userId = _ref7.userId,
          challengeId = _ref7.challengeId;
      return _this.api["delete"]("/v3/users/".concat(userId, "/clients/").concat(clientId, "/challenges/").concat(challengeId, "/leaderboard"));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserRegisteredChallenges", function () {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          clientId = _ref8.clientId,
          userId = _ref8.userId,
          params = _ref8.params;

      return _this.api.get("/v3/users/".concat(userId, "/clients/").concat(clientId, "/registered-challenges"), {
        params: params
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserRegisteredChallengesNew", function (_ref9) {
      var userId = _ref9.userId,
          clientId = _ref9.clientId,
          limit = _ref9.limit,
          skip = _ref9.skip,
          status = _ref9.status,
          search = _ref9.search;
      return _this.api.get("/v3/users/".concat(userId, "/challenges/registered"), {
        params: {
          clientId: clientId,
          limit: limit,
          skip: skip,
          status: status,
          search: search
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "registerChallenge", function (_ref10) {
      var userId = _ref10.userId,
          clientId = _ref10.clientId,
          payload = _ref10.payload;
      return _this.api.post("/v3/users/".concat(userId, "/clients/").concat(clientId, "/challenges"), {
        params: {
          'client-id': clientId
        },
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "unregisterChallenge", function (_ref11) {
      var userId = _ref11.userId,
          clientId = _ref11.clientId,
          challengeId = _ref11.challengeId;
      return _this.api["delete"]("/v3/users/".concat(userId, "/clients/").concat(clientId, "/challenges/").concat(challengeId), {
        data: {}
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "restartChallenge", function (_ref12) {
      var userId = _ref12.userId,
          clientId = _ref12.clientId,
          challengeId = _ref12.challengeId;
      return _this.api.post("/v3/users/".concat(userId, "/clients/").concat(clientId, "/challenges/").concat(challengeId, "/restart"), {
        params: {
          'client-id': clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserChallengeActivities", function (_ref13) {
      var userId = _ref13.userId,
          clientId = _ref13.clientId,
          challengeId = _ref13.challengeId;
      return _this.api.get("/v3/users/".concat(userId, "/clients/").concat(clientId, "/challenges/").concat(challengeId, "/activities"), {});
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserChallengeActions", function (_ref14) {
      var userId = _ref14.userId,
          clientId = _ref14.clientId,
          challengeId = _ref14.challengeId;
      return _this.api.get("/v3/users/".concat(userId, "/clients/").concat(clientId, "/challenges/").concat(challengeId, "/user-actions"), {});
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserChallengeActivitiesAround", function (_ref15) {
      var userId = _ref15.userId,
          clientId = _ref15.clientId,
          challengeId = _ref15.challengeId;
      return _this.api.get("/v3/users/".concat(userId, "/clients/").concat(clientId, "/challenges/").concat(challengeId, "/activities/around"), {});
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserChallengeBadges", function (_ref16) {
      var userId = _ref16.userId,
          clientId = _ref16.clientId,
          limit = _ref16.limit,
          skip = _ref16.skip,
          challengeType = _ref16.challengeType;
      return _this.api.get("/v3/users/".concat(userId, "/challenges/badges"), {
        params: {
          clientId: clientId,
          limit: limit,
          skip: skip,
          challengeType: challengeType
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteUserRedeemFromReward", function (_ref17) {
      var userId = _ref17.userId,
          rewardId = _ref17.rewardId;
      return _this.api["delete"]("/v3/users/".concat(userId, "/rewards/").concat(rewardId), {
        data: {}
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserChallenge", function (_ref18) {
      var challengeId = _ref18.challengeId,
          clientId = _ref18.clientId,
          userId = _ref18.userId;
      return _this.api.get("/v3/users/".concat(userId, "/clients/").concat(clientId, "/challenges/").concat(challengeId, "/userChallenge"));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateUserChallenge", function (_ref19) {
      var userId = _ref19.userId,
          clientId = _ref19.clientId,
          challengeId = _ref19.challengeId,
          data = _ref19.data;
      return _this.api.put("/v3/users/".concat(userId, "/clients/").concat(clientId, "/challenges/").concat(challengeId), {
        data: data
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addMember", function (_ref20) {
      var groupId = _ref20.groupId,
          clientId = _ref20.clientId,
          token = _ref20.token;
      return _this.api.post("/v3/groups/".concat(groupId, "/members"), {
        data: {
          client: clientId
        },
        headers: token ? {
          Authorization: token
        } : {}
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserReward", function (_ref21) {
      var rewardId = _ref21.rewardId,
          clientId = _ref21.clientId,
          userId = _ref21.userId;
      return _this.api.get("/v3/users/".concat(userId, "/rewards/").concat(rewardId), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getRewards", function (_ref22) {
      var clientId = _ref22.clientId,
          isGroupFiltered = _ref22.isGroupFiltered,
          skip = _ref22.skip,
          limit = _ref22.limit,
          category = _ref22.category,
          groupIds = _ref22.groupIds,
          countries = _ref22.countries,
          search = _ref22.search;
      return _this.api.get("/v3/rewards", {
        params: {
          clientId: clientId,
          isGroupFiltered: isGroupFiltered,
          skip: skip,
          limit: limit,
          category: category,
          groupIds: groupIds,
          countries: countries,
          search: search
        }
      });
    });
    return _this;
  }

  return UsersCoreApi;
}(_createApi.BaseApi);

var _default = UsersCoreApi;
exports["default"] = _default;
//# sourceMappingURL=usersCore.js.map